import Vue from "vue";
import Router from "vue-router";
// import VueGtm from "vue-gtm";

import HomeRouter from "./views/HomeRouter.vue";
import DefaultTemplate from "./templates/Default.vue";
import store from "./store";

Vue.use(Router);

const CONTENT_SCOPED_ROUTES = {
  module: "content-module",
  lesson: "content-lesson",
  "lesson-quiz": "content-lesson-quiz",
  search: "content-search",
  "my-list": "content-my-list",
  "ebook-viewer": "content-ebook-viewer"
};

const vueRouter = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeRouter,
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/buscar",
      name: "search",
      component: () => import("./views/Search.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/modulo/:id",
      name: "module",
      component: () => import("./views/Module.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/modulo/:id/aula/:lesson",
      name: "lesson",
      component: () => import("./views/Lesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/modulo/:id/quiz/:quiz",
      name: "lesson-quiz",
      component: () => import("./views/LessonQuiz.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/ebook/:fileId",
      name: "ebook-viewer",
      component: () => import("./views/EbookViewer.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/minha-conta",
      name: "account",
      component: () => import("./views/Account.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/comunidade/:id",
      name: "community",
      component: () => import("./components/community/views/Community.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/comunidade/:id/foruns",
      name: "community-forums",
      component: () => import("./components/community/views/ForumsView.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/comunidade/:id/forum/:forumId",
      name: "community-forum",
      component: () => import("./components/community/views/ForumView.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/comunidade/:id/forum/:forumId/topico/:postId",
      name: "community-topic",
      component: () => import("./components/community/views/TopicView.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/minha-lista",
      name: "my-list",
      component: () => import("./views/MyList.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId",
      name: "content-home",
      component: HomeRouter,
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId/buscar",
      name: "content-search",
      component: () => import("./views/Search.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId/modulo/:id",
      name: "content-module",
      component: () => import("./views/Module.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId/modulo/:id/aula/:lesson",
      name: "content-lesson",
      component: () => import("./views/Lesson.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId/modulo/:id/quiz/:quiz",
      name: "content-lesson-quiz",
      component: () => import("./views/LessonQuiz.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId/ebook/:fileId",
      name: "content-ebook-viewer",
      component: () => import("./views/EbookViewer.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/c/:contentProductId/minha-lista",
      name: "content-my-list",
      component: () => import("./views/MyList.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/acesso-bloqueado",
      name: "sale",
      component: () => import("./views/Sale.vue"),
      meta: {
        template: DefaultTemplate,
        protected: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/token",
      name: "token",
      component: () => import("./views/Token.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("./views/ResetPassword.vue"),
      meta: {
        template: () => import("./templates/Auth.vue"),
        protected: false
      }
    },
    {
      path: "/termos-de-uso",
      name: "terms",
      component: () => import("./views/Terms.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "/politicade-privacidade-2021",
      name: "privacy",
      component: () => import("./views/Privacy.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/NotFound.vue"),
      meta: {
        template: () => import("./templates/Blank.vue"),
        protected: false
      }
    }
  ]
});

// Vue.use(VueGtm, {
//   id: "GTM-TB4VDDF",
//   vueRouter
// });

vueRouter.beforeEach((to, from, next) => {
  const contentProductId = to.params.contentProductId || null;
  const activeContentProductId = store.state.activeContentProductId;

  if (
    !contentProductId &&
    activeContentProductId &&
    CONTENT_SCOPED_ROUTES[to.name]
  ) {
    next({
      name: CONTENT_SCOPED_ROUTES[to.name],
      params: {
        ...to.params,
        contentProductId: String(activeContentProductId)
      },
      query: to.query,
      replace: true
    });
    return;
  }

  store.commit("setActiveContent", contentProductId);
  next();
});

export default vueRouter;
